import { WebPlugin } from '@capacitor/core';
export class SumsubMobileSdkWeb extends WebPlugin {
    async initialize() {
        throw this.unimplemented('Not implemented on web.');
    }
    async present() {
        throw this.unimplemented('Not implemented on web.');
    }
    async dismiss() {
        throw this.unimplemented('Not implemented on web.');
    }
    async setAccessToken() {
        throw this.unimplemented('Not implemented on web.');
    }
    async getVerificationStatus() {
        throw this.unimplemented('Not implemented on web.');
    }
    async addListener() {
        throw this.unimplemented('Not implemented on web.');
    }
}
//# sourceMappingURL=web.js.map